// THE image URL resolver — every component that shows a CMS image (products, homepage, industries, clients,
// testimonials, mega menu, media previews …) resolves its stored value through this one function.
//
// What the database stores is a stable, host-independent reference: `/api/uploads/<folder>/<file>` for uploaded
// media, `/images/...` for files shipped with the site, or a full third-party https URL. The host is added HERE, at
// render time, so the same stored value works on localhost and on https://shingare.com.
//
// Older records were saved with a host baked in (`https://shingare.com/api/uploads/...`, or worse
// `http://localhost:8000/api/uploads/...` when uploaded from a developer machine). An uploaded file is only ever served
// by our own backend, so an `/api/uploads/...` path is always re-pointed at the CURRENT backend, whatever host was saved.
const BASE = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
const UPLOAD_ON_ANY_HOST = /^https?:\/\/[^/]+(\/api\/uploads\/.+)$/i;

export function imageUrl(url) {
  const s = String(url || "").trim();
  if (!s) return "";
  const own = s.match(UPLOAD_ON_ANY_HOST);
  if (own) return `${BASE}${own[1]}`;
  if (/^https?:\/\//i.test(s)) return s; // third-party image: leave alone
  if (s.startsWith("/api/uploads")) return `${BASE}${s}`;
  if (s.startsWith("/uploads")) return `${BASE}/api${s}`; // very old records
  return s; // /images/..., data:, relative site assets
}

// Historical name still used all over the codebase — same function, so there is exactly one behaviour.
export const toAbsoluteUrl = imageUrl;

/** The storable, host-independent form of a chosen upload (what the Media picker writes into the database). */
export function storedImageRef(url) {
  const s = String(url || "").trim();
  const own = s.match(UPLOAD_ON_ANY_HOST);
  return own ? own[1] : s;
}
